import { object } from 'prop-types';
import React from 'react';

import TextField from '../../FormFields/TextField';

const TotalDurationFields = ({
    errors,
    touched,
    values,
    ...props
}) => (
    <>
        <TextField
            autoComplete="off"
            errors={errors.ruleAggregateCount}
            helperText="Enter a value in hours"
            label="Aggregate Total Duration"
            name="ruleAggregateCount"
            required
            touched={touched.ruleAggregateCount}
            type="number"
            value={values.ruleAggregateCount}
            {...props}
        />
        <TextField
            autoComplete="off"
            errors={errors.ruleAggregateDuration}
            helperText="Enter a value in hours"
            label="Aggregate Duration"
            name="ruleAggregateDuration"
            required
            touched={touched.ruleAggregateDuration}
            type="number"
            value={values.ruleAggregateDuration}
            {...props}
        />
    </>
);

TotalDurationFields.defaultProps = {
    errors:  {},
    touched: {},
    values:  {}
};

TotalDurationFields.propTypes = {
    errors:  object,
    touched: object,
    values:  object
};

export default TotalDurationFields;
